/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createResultSet } from '../../factoriesAny.js';
export var ResultSetDependencies = {
  createResultSet
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesResultSet.generated.js
// module id = 561
// module chunks = 2